import $ from 'jquery';
import '../styles/main.scss';
import {setupHeader} from './header'
import HamburgerMenu from "./hamburger-menu";
import elementIsVisibleOrScrolledPast from "./elementIsVisibleOrScrolledPast";

export const win = $(window);

const hamburgerMenu = new HamburgerMenu();

function setHeaderColorWhenOverTextContainer(textContainers) {
    if (textContainers) {
        if (elementIsVisibleOrScrolledPast(textContainers[0])) {
            document.querySelector('header').classList.add('white')
        } else {
            document.querySelector('header').classList.remove('white')
        }
    }
}

(function (window, $) {
    $(document).ready(() => {
        // const elementsWithTransparentHeader = $('.cross-scroll--section');
        const startPage = $('body.front-page');
        // const topImageSection = $('.cross-scroll--section');

        setupHeader();

        if (!startPage.length) {
            const textContainers = $('.l-container--text');

            let timeout;

            const debouncedScrollHandler = () => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {

                    setHeaderColorWhenOverTextContainer(textContainers);
                    // setColorOnVisibility(isVisible, currentElement);
                }, 200);
            };

            // setHeaderColorWhenOverTextContainer(textContainers);

            if (textContainers) {
                // first check for onscreen on init;
                window.addEventListener('scroll', debouncedScrollHandler, {passive: true});

            }
        }
    });

    $(document).on('click', '#hamburger-menu',  hamburgerMenu.handleClick)

})(window, $);
